import { render, staticRenderFns } from "./StatsPage.vue?vue&type=template&id=1ec23b3c"
import script from "./StatsPage.vue?vue&type=script&lang=js"
export * from "./StatsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports